/** Client flag for a company-code simulate login. Password login clears it. */
const SIMULATED_LOGIN_FLAG = 'air8-simulated-login'

export function markSimulatedLoginSession () {
  localStorage.setItem(SIMULATED_LOGIN_FLAG, '1')
}

export function clearSimulatedLoginSession () {
  localStorage.removeItem(SIMULATED_LOGIN_FLAG)
}

export function hasSimulatedLoginSession (): boolean {
  return localStorage.getItem(SIMULATED_LOGIN_FLAG) === '1'
}

export function isSimulatedLoginFlag (value: unknown): boolean {
  return value === true || value === 'true' || value === 1 || value === '1'
}

export function syncSimulatedLoginSession (user: { simulatedLogin?: unknown } | null | undefined) {
  if (isSimulatedLoginFlag(user?.simulatedLogin)) markSimulatedLoginSession()
  else clearSimulatedLoginSession()
}

export function isDashboardAppPath (path: string): boolean {
  return path === '/dashboard' || path.startsWith('/dashboard/')
}

export function isShareAppPath (path: string): boolean {
  return path === '/share' || path.startsWith('/share/')
}

export type SimulatedRouteDecision = 'allow' | 'enter-dashboard' | 'password-login'

/** Simulated sessions may stay on share (entry) and /dashboard/*. Other app routes require a password login. */
export function simulatedRouteDecision (path: string): SimulatedRouteDecision {
  if (!path || path === '/') return 'enter-dashboard'
  if (isDashboardAppPath(path) || isShareAppPath(path)) return 'allow'
  if (
    path === '/login' ||
    path === '/reset-pwd' ||
    path === '/teams-email' ||
    path.startsWith('/error/')
  ) {
    return 'allow'
  }
  return 'password-login'
}

export function readCompanyCode (value: unknown): string {
  const raw = Array.isArray(value) ? value[0] : value
  if (raw == null) return ''
  return String(raw).trim()
}

const DASHBOARD_ENTRY_CANDIDATES = [
  '/dashboard/ct',
  '/dashboard/ar',
  '/dashboard/asp',
  '/dashboard/non-ar',
  '/dashboard/cashflow'
]

export function resolveSimulatedDashboardEntry (canAccess: (path: string) => boolean): string {
  return DASHBOARD_ENTRY_CANDIDATES.find(path => canAccess(path)) || '/dashboard/ar'
}
